document.documentElement.classList.remove("anti-flicker-hide");
function main() {
  const client = ShopifyBuy.buildClient({
    accessToken: "77582b62efde9c098c335a99908b43c7",
    domain: "audienhearing.com",
    appId: "60039036929",
  });

  const cardWhites = document.querySelectorAll(".card-white");
  const checkoutButton = document.getElementsByClassName("buy-now-btn")[0];
  const orderNowButtons = [...document.querySelectorAll(".card")];
  const atomProChecks = [...document.querySelectorAll(".atom-pro-upgrade")];
  const atomChecks = [...document.querySelectorAll(".remove-upgrade")];

  cardWhites.forEach(function (card) {
    card.onclick = function () {
      const discountCode = card.dataset.discountCode; // Extract discount code
      const discountedPrice = card.dataset.discountedPrice; // Extract discounted price
      client.createCart().then((cart) => {
        client.fetchProduct(card.dataset.productId).then((p) => {
          cart
            .createLineItemsFromVariants({
              variant: p.variants[0],
              quantity: 1,
            })
            .then((cart2) => {
              updateCheckoutUrl(cart2, discountCode, discountedPrice); // Pass discounted price
            });
        });
      });
    };
  });

  function updateCheckoutUrl(cart, discountCode, discountedPrice) {
    const checkoutUrl = new URL(cart.checkoutUrl);
    if (discountCode) {
      checkoutUrl.searchParams.append("discount", discountCode);
    }

    checkoutButton.onclick = function () {
      window.location.href = checkoutUrl.href; // Updated URL with discount code
    };

    // Display discounted price as the subtotal
    const subtotalElement =
      document.getElementsByClassName("checkout-subtotal")[0];
    if (discountedPrice) {
      subtotalElement.textContent = `Total: $${Number(discountedPrice).toFixed(
        2
      )}`;
    } else {
      subtotalElement.textContent = `Total: $${Number(cart.subtotal).toFixed(
        2
      )}`;
    }
    subtotalElement.style.display = "block";
  }

  orderNowButtons.forEach(function (button) {
    button.onclick = function () {
      const id = button.dataset.productId;
      const discountCode = button.dataset.discountCode; // Extract discount code
      const discountedPrice = button.dataset.discountedPrice; // Extract discounted price
      client.fetchProduct(id).then(function (product) {
        client.createCart().then(function (emptyCart) {
          const variant = { variant: product.variants[0], quantity: 1 };
          emptyCart.createLineItemsFromVariants(variant).then(function (cart) {
            document.querySelector(
              ".div-block-69.floating-co-btn.at-end"
            ).style.display = "flex";
            updateCheckoutUrl(cart, discountCode, discountedPrice); // Pass discounted price
            atomProChecks.forEach(function (proCheck) {
              proCheck.onclick = function () {
                if (proCheck.dataset.checked === "true") return;
                proCheck.dataset.checked = "true";
                proCheck.parentNode.parentNode.querySelector(
                  ".remove-upgrade"
                ).dataset.checked = "false";
                client.fetchProduct("7163267612735").then(function (product) {
                  const variant = {
                    variant: product.variants[0],
                    quantity: 1,
                  };
                  cart
                    .createLineItemsFromVariants(variant)
                    .then(function (cart) {
                      updateCheckoutUrl(cart, discountCode, discountedPrice); // Pass discounted price
                      activateAtomChecks(cart);
                    });
                });
              };
            });
          });
        });
      });
    };
  });

  function activateAtomChecks(cart) {
    atomChecks.forEach(function (check) {
      check.onclick = function () {
        if (check.dataset.checked === "true") return;
        check.dataset.checked = "true";
        check.parentNode.parentNode.querySelector(
          ".atom-pro-upgrade"
        ).dataset.checked = "false";
        if (cart.lineItems[1]) {
          client.fetchProduct("7163267612735").then(function (product) {
            if (cart.lineItems[1].quantity === 1) {
              cart.removeLineItem(cart.lineItems[1].id).then(function (cart) {
                document.querySelector(
                  ".div-block-69.floating-co-btn.at-end"
                ).style.display = "flex";
                updateCheckoutUrl(cart);
              });
            } else {
              cart
                .updateLineItem(
                  cart.lineItems[1].id,
                  cart.lineItems[1].quantity - 1
                )
                .then(function () {
                  document.querySelector(
                    ".div-block-69.floating-co-btn.at-end"
                  ).style.display = "flex";
                  updateCheckoutUrl(cart);
                });
            }
          });
        }
      };
    });
  }
}
main();
